export default __webpack_public_path__ + "static/media/h5-bg2.888bb7e7.png";